type Props = {
  className?: string
}

const CardsWidget7 = ({className}: Props) => (
  <div className={`card card-flush ${className}`}>
    <div className='card-header pt-5'>
      <div className='card-title d-flex flex-column'>
        <div className='d-flex align-items-center'>
          <span className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2'>1024</span>
        </div>
        <span className='text-muted pt-2'>
          Total unique programs funded by IIJA / IRA in Colorado to date. *
        </span>
        <div className='d-flex align-items-center mt-2'>
          <span className='fs-4 fw-semibold text-gray-400 mt-5 me-1 align-self-start'>$</span>
          <span className='fs-2hx fw-bold text-dark me-2 mt-5 lh-1 ls-n2'>3,159,925</span>
        </div>
        <span className='text-gray-400 pt-1 fw-semibold fs-6'>Average Program Funding</span>
      </div>
      <div className='card-body d-flex flex-column justify-content-end pe-0'></div>
    </div>
  </div>
)

export {CardsWidget7}
